
    import {Component, Vue, Watch} from 'vue-property-decorator';
    import {
        dictApi,
        dictInstrumentApi
    } from "@/api/organization";
    import {IPage} from "@/js/page";
    import SetTableColumns from "@/components/SetTableColumns.vue";
    import TableShowRangeHead from "@/components/table-show-range-head.vue";
    import TableShowRangeBody from "@/components/table-show-range-body.vue";
    import ckeditor4 from "@/components/CkeditorComponent.vue";

    @Component({name:'Sys_InstrumentName',components: {SetTableColumns,TableShowRangeHead, TableShowRangeBody,ckeditor4}})
    export default class Home extends Vue {
        title = '器具字典';
        listParam: IPage = {
            size: 10,
            current: 1,
        };
        listTotal = 0;
        propParams = {
            // hostName: "",   //主名称
            rulesNumber: "",   //规范编号
            ruleName: "",   //规范名称
            strong: "",    //强检
            name: "",      //名称
            parentId: "",  //类别
            catalogue: [],
        } as any
        showForm = false;
        tabCol = [];
        saving = false
        addform = this.resetDataFrom() as any
        formRules = {
            name: [{required: true, message: '请输入名称', trigger: 'blur'}],
            nameList: [{required: true, message: '请设置器具名称', trigger: 'blur'}],
        }
        moveRules = {
            name: [{required: true, message: '请输入移动到的器具名称', trigger: 'blur'}],
        }
        dataDialog = {
            visible: false,
        }
        name = [];
        listInstrument = [] as any //器具备选列表
        instrCatalogueTree = [] as any //器具目录数据列表
        instrumentObj = {} as any // 器具结果
        list = [] as any;   //表格展示
        props = {
            value: 'id',
            label: 'name',
            checkStrictly: true,
            emitPath: false
        }
        showAllLevels = false;
        allSelected = [];
        itemKey = 0;
        loading = false;

        moveActiveArr = [];
        moveDialog = false;
        moveForm = {
            name: "",
        }
        moveToDataList = [];  //目标id备选列表

        moveType = 5;  //5移动， 6替换

        created() {
            this.getListInstrument();
        }
        get addformName(){
            return this.addform.nameList.slice(1);
        }
        activated(){
            if (this.$route.meta && !this.$route.meta.isBack) {
                this.showForm = false;
                this.reset();
            }else{
                this.getList();
            }
            this.tableClearSelect();
        }
        getList() {
            const form = JSON.parse(JSON.stringify(this.propParams));
            // if(this.name.length > 0){
            //     form.parentId = this.name[this.name.length - 1];
            // }
            if(form.catalogue.length > 0){
                form.catalogueOne = form.catalogue[0];
            }
            if(form.catalogue.length > 1){
                form.catalogueTwo = form.catalogue[1];
            }
            form.catalogue = null;
            form.parentId = this.name;
            const params = {
                ...this.listParam,
                ...form,
            } as any;
            this.loading = true;
            dictInstrumentApi.list(params).then(r => {
                if (r.data.result === 0) {
                    const rData = r.data.data.records;
                    this.listTotal = r.data.data.total;
                    rData.map((e:any)=>{
                        for(const n1 of this.listInstrument){
                            if(n1.children){
                                for(const n2 of n1.children){
                                    if(n2.children){
                                        for(const n3 of n2.children){
                                            if(n3.id === e.parentId){
                                                e.name1 = n1.name;
                                                e.name2 = n2.name;
                                                e.name3 = n3.name;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    })
                    this.list = rData;
                }
                this.$nextTick(() => {
                    let $table = this.$refs.table as HTMLFormElement;
                    if ($table) {
                        $table.doLayout();
                    }
                    this.itemKey = Math.random();
                    this.loading = false;
                })
            })
        }
        querySearchAsync1(queryString: string, cb: any) {
            this.querySearchAsync(queryString,0,cb)
        }
        querySearchAsync2(queryString: string, cb: any) {
            cb(this.querySearchAsync(queryString,2,cb))
        }
        querySearchAsync(queryString: string, type: number, cb: any){
            if(queryString == "") return;
            dictInstrumentApi.listDictInstrumentNames({
                name: queryString,
                type: type,   //1主名称  2别名
                size: 1000,
                current: 1,
            }).then(r => {
                if (r.data.result === 0) {
                    const rData = r.data.data.records;
                    this.moveToDataList = rData;
                    rData.map((e:any)=>e.value = e.name);
                    cb(rData);
                }
            })
        }
        //获取器具备选列表个
        getListInstrument(){
            dictApi.listDictInstrument().then(r=>{
                if (r.data.result === 0) {
                    const rData = r.data.data;
                    this.porjectTree(rData, 0);
                    this.listInstrument = rData;
                    this.getList();
                }
            })
            dictApi.listInstrumentCatalogueTree().then((r) => {
                if (r.data.result === 0) {
                    const rData = r.data.data;
                    this.porjectTreeV2(rData);
                    this.instrCatalogueTree = rData;
                }
            });
        }
        porjectTreeV2(projectList: any){
            projectList.forEach((project: any) => {
                if(project.children.length == 0){
                    project.children = null;
                }else{
                    this.porjectTreeV2(project.children);
                }
            })
        }
        porjectTree(projectList: any, level: number){
            projectList.forEach((project: any) => {
                if(level === 2){
                    this.instrumentObj[project.instrumentNameId] = project.children;
                    project.children2 = project.children;
                    project.children = null;
                }else{
                    this.porjectTree(project.children, (level+1));
                }
            })
        }
        nameChange(value: any){
            if(value.length >= 2){
                // this.list = this.instrumentObj[value[2]];
                this.getListDictInstrumentName(value[2]);
            }else if(value.length == 0){
                this.list = [];
            }
        }
        memberSelect(selection: any, row: any) {
            this.allSelected = selection;
        }
        detail(data: any) {
            let id = data.id;
            this.$router.push(`/sys/instrumentNameDetail/2/${id}`);
        }
        //0新增  1编辑 2查看  3删除 4添加别名 5移动  6替换
        toDetail(type: number){
            this.addform = this.resetDataFrom();
            const dataArr = this.allSelected as any;
            let id = 0;
            if(type !== 0){
                if(dataArr.length == 0){
                    this.$message.error("请先勾选");
                    return;
                }
                if(type == 3){
                    this.del(dataArr);
                    return;
                }
                if(type == 5){
                    this.move(dataArr, type);
                    return;
                }
                if(dataArr.length > 1 && (type == 1 || type == 2 || type == 6)){
                    this.$message.error("只能勾选一条");
                    return;
                }
                id = dataArr[0].id;
                // const obj = this.list.find((e:any)=>e.id == id);
                // if(obj){
                //     const obj2 = this.cloneObjectFn(obj);
                //     this.addform = obj2;
                // }
                if(type==4){
                    this.getName(id);
                    return;
                }
                if(type == 6){
                    //替换只能单选
                    this.move(dataArr, type);
                    return;
                }
            }
            this.$router.push(`/sys/instrumentNameDetail/${type}/${id}`);
            // this.dataDialog.visible = true;
        }
        move(dataArr: any, type: number){
            this.moveType = type;
            this.moveActiveArr = dataArr;
            this.moveDialog = true;
        }
        moveSave(){
            let form = this.$refs.moveForm as HTMLFormElement;
            form.validate((valid:any) => {
                if (valid) {
                    const toData = this.moveToDataList.find((e: any)=>e.name == this.moveForm.name) as any;
                    if(!toData){
                        this.$alert("请在下拉框中选择一个器具");
                        return;
                    }
                    const fromIdArr = this.moveActiveArr.flatMap((e:any) => e.id);
                    if(fromIdArr.indexOf(toData.dictInstrumentId) != -1){
                        this.$alert("不能"+(this.moveText)+"给自己");
                        return;
                    }
                    const params = {
                        fromIds: fromIdArr.join(","),
                        toId: toData.dictInstrumentId,
                        majorCode: 0,
                        classCode: 0,
                        categoryCode: 0,
                        majorName: "",
                        className: "",
                        categoryName: "",
                    }
                    for(const n1 of this.listInstrument){
                        if(n1.children){
                            for(const n2 of n1.children){
                                if(n2.children){
                                    for(const n3 of n2.children){
                                        if(n3.children2){
                                            for(const n4 of n3.children2){
                                                if(n4.instrumentNameId === toData.id){
                                                    params.majorCode = n1.instrumentNameId;
                                                    params.classCode = n2.instrumentNameId;
                                                    params.categoryCode = n3.instrumentNameId;
                                                    params.majorName = n1.name;
                                                    params.className = n2.name;
                                                    params.categoryName = n3.name;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    if(params.majorCode == 0){
                        this.$alert("所选器具找不到对应的项别、种别、类别");
                        return;
                    }
                    let api;
                    if(this.moveType == 5){
                        api = dictInstrumentApi.mergeInstrument(params);
                    }else{
                        const params2 = {
                            dictInstrumentId: fromIdArr[0],
                            instrumentNameId: toData.id
                        }
                        api = dictInstrumentApi.moveInstrument(Object.assign(params, params2));
                    }
                    this.saving = true;
                    api.then(r=>{
                        if(r.data.result === 0){
                            this.$message.success(this.moveText+"成功");
                            this.closeMoveDialog();
                            this.getListInstrument();
                        }
                    }).finally(()=>{
                        this.saving = false;
                    })
                }
            });
        }
        get moveText(){
            let str = "";
            if(this.moveType==5){
                str = '移动';
            }else if(this.moveType==6){
                str = '替换';
            }
            return str;
        }
        //获取器具别名，进行编辑
        getName(instrumentId: number){
            dictInstrumentApi.listDictInstrumentNames({
                name: "",
                type: "0",   //1主名称  2别名
                size: 100,
                current: 1,
                instrumentId: instrumentId
            }).then(r => {
                if (r.data.result === 0) {
                    const rData = r.data.data.records;
                    rData.sort((a: any, b: any) => a.type - b.type);
                    this.addform.nameList = rData;
                    this.addform.id = instrumentId;
                    this.dataDialog.visible = true;
                    this.$nextTick(() => {
                        let $table = this.$refs.tableName as HTMLFormElement;
                        if ($table) {
                            $table.doLayout();
                        }
                        let $form = this.$refs.form as HTMLFormElement;
                        if ($form) {
                            $form.clearValidate();
                        }
                    })
                }
            })
        }
        del(dataArr: any){
            this.$confirm('确定要删除'+dataArr.flatMap((e:any)=>e.name).join(",")+'？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                dictInstrumentApi.delInstrument({ids: dataArr.flatMap((e:any)=>e.id).join(",")}).then(r => {
                    if (r.data.result === 0) {
                        this.$message.success("删除成功");
                        this.tableClearSelect();
                        this.getListInstrument();
                    }else if(r.data.result === 1){
                        this.$alert(r.data.message,{
                            dangerouslyUseHTMLString: true
                        });
                    }
                })
            }).catch(() => {
                console.log("取消")
            });
        }
        closeDialog(){
            this.resetDataFrom();
            this.dataDialog.visible = false;
        }
        closeMoveDialog(){
            this.moveForm.name = "";
            this.moveDialog = false;
            let $form = this.$refs.moveForm as HTMLFormElement;
            if($form){
                $form.resetFields();
            }
        }
        tableClearSelect(){
            this.allSelected = [];
            let $table = this.$refs.table as HTMLFormElement;
            if($table){
                $table.clearSelection();
            }
        }
        cloneObjectFn(obj: any) {
            return JSON.parse(JSON.stringify(obj));
        }
        resetDataFrom() {
            return {
                id: 0,  //器具id
                strong: "",
                nameList: [{name: "",id:0}],
            }
        }
        addData() {
            let form = this.$refs.form as HTMLFormElement;
            form.validate((valid: any) => {
                if (valid) {
                    const form = this.cloneObjectFn(this.addform);
                    const person = form.nameList;
                    //判断重名
                    const nameArr = person.flatMap((e:any)=>e.name);
                    if(new Set(nameArr).size != nameArr.length){
                        this.$alert("存在重名，请修改");
                        return;
                    }
                    person.map((e:any)=>e.dictInstrumentId = form.id);
                    this.saving = true;
                    dictInstrumentApi.changeInstrumentName(person).then(data => {
                        if (data.data.result === 0) {
                            this.$message.success("编辑成功");
                            this.dataDialog.visible = false;
                            this.tableClearSelect();
                            this.getListInstrument();
                        }
                    }).finally(()=>{
                        this.saving = false;
                    })
                }
            })
        }
        //获取第四级列表数据
        getListDictInstrumentName(id: number){
            dictApi.listDictInstrumentName({parentId: id}).then(data => {
                if (data.data.result === 0) {
                    const rData = data.data.data;
                    const arr = [];
                    for(const i in rData){
                        const thisData = rData[i];
                        thisData.map((e:any)=>e.id=e.instrumentNameId);
                        if(thisData.length > 0){
                            arr.push({
                                name: thisData.flatMap((e:any)=>e.name).join(","),
                                strong: rData[i][0].strong?true:false,
                                nameList: thisData,
                                id: i
                            })
                        }
                    }
                    this.list = arr;
                }
            });
        }
        addNameList(){
            const data = {name: "",id: 0, type: 2};
            this.addform.nameList.push(data);
        }
        deleteNameList(index: number){
            this.addform.nameList.splice(index, 1);
        }
        moveoutNameList(index: number){
            const obj = this.addform.nameList[index];
            this.$confirm('确定要将【'+obj.name+'】移出【'+this.addform.nameList[0].name+'】吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                dictInstrumentApi.splitInstrument({instrumentId:obj.id}).then((data) => {
                    if (data.data.result === 0) {
                        this.$message.success("移出成功");
                        this.addform.nameList.splice(index, 1);
                        this.getListInstrument();
                        this.closeDialog();
                    }
                });
            }).catch(() => {
                console.log("取消")
            });
        }
        indexMethod(index: any) {
            return (this.listParam.current-1)*this.listParam.size+index+1;
        }
        refresh() {
            this.listParam.current = 1;
            this.getList();
        }
        reset() {
            for (const f in this.propParams) {
                this.propParams[f] = "";
            }
            this.name = [];
            this.refresh();
        }
        pageSizeChange(val: number) {
            this.listParam.size = val;
            this.getList();
        }

        pageCurrentChange(val: number) {
            this.listParam.current = val;
            this.getList();
        }
        changeTabCol(e: any) {
            this.tabCol = e;
            this.$nextTick(()=>{
                let $table = this.$refs.table as HTMLFormElement;
                if($table){
                    $table.doLayout();
                }
            })
        }
        parseParamList(jsonString: string){
            if(jsonString){
                return JSON.parse(jsonString);
            }
        }
    }
